import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { pageNames } from '@common/constants/RouteMap';

import { useAuthentication } from '@libs/acp/contexts';
import { getCookie } from '@libs/utils/helpers/getSafeCookies';
import constants from '@libs/acp/common/constants';

const MFAPositiveDataRoutes = () => {
	const { isAuthenticated } = useAuthentication();

	const location = useLocation();
	const { state } = location;

	const cookiePassed = getCookie(constants.cookies.MFA_POSITIVE_DATA_PASSED);
	const statePassed = state?.unlockedPositiveData;
	const hasEnabledMFAPositiveData = isAuthenticated && (statePassed || cookiePassed);

	if (!hasEnabledMFAPositiveData) return <Navigate to={pageNames.mfaPositiveData.path} state={{ featureName: "CADASTRO POSITIVO", from: location.pathname }} />;

  return (<Outlet />);
};

export default MFAPositiveDataRoutes;
